import { render, staticRenderFns } from "./AiSubscriptionBadge.vue?vue&type=template&id=ab01998e&scoped=true"
import script from "./AiSubscriptionBadge.vue?vue&type=script&lang=js"
export * from "./AiSubscriptionBadge.vue?vue&type=script&lang=js"
import style0 from "./AiSubscriptionBadge.vue?vue&type=style&index=0&id=ab01998e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab01998e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
